<template>
  <div>
    <page-header>
      <div class="text-nowrap text-dark ml-3 mr-3">
        <h4 class="form-check-label">
          {{ boardTitle }}
        </h4>
      </div>

      <router-link
        tag="div"
        class="badgebutton active text-nowrap ml-4"
        :to="{ name: 'Board', params: { id: $route.params.id } }"
      >
        <i class="far fa-caret-left"></i>
        Back to Board
      </router-link>
    </page-header>

    <BoardSettings />
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import { SettingsStore, SettingsModule } from '@/store/settings';
  import BoardSettings from '@/components/Board/BoardSettings.vue';

  @Component({
    components: {
      PageHeader,
      BoardSettings,
    },
  })
  export default class BoardSettingsComponent extends Vue {
    private settings: SettingsModule = SettingsStore;

    get boardTitle() {
      return this.settings.initialBoardSettings.title;
    }

    async mounted() {
      await this.settings.loadBoardInitialSettings(this.$route.params.id);
    }
  }
</script>